import { render, staticRenderFns } from "./Afiliate.vue?vue&type=template&id=ee724522&scoped=true&lang=pug&"
import script from "./Afiliate.vue?vue&type=script&lang=js&"
export * from "./Afiliate.vue?vue&type=script&lang=js&"
import style0 from "./Afiliate.vue?vue&type=style&index=0&id=ee724522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee724522",
  null
  
)

export default component.exports